import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Row,
  Col,
  Button,
  Alert,
  Spinner,
  Modal,
  Table,
  OverlayTrigger,
  Tooltip,
  Breadcrumb,
  ButtonGroup,
  Dropdown,
} from "react-bootstrap";
import toastr from "toastr";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
//imports de components
import config from "../../../config";
import CustomPagint from "../../../components/CustomPagint";
import { Typeahead } from "react-bootstrap-typeahead";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarDashboard from "../../../components/SidebarDashboard";
import LinkDescargaListGD from "../../../components/gestorDocumental/LinkDescargaListGD";
import LinkDescargaGD from "../../../components/gestorDocumental/LinkDescargaGD";
//imports de redux
import {
  editWorkFlowTaskList,
  getWorkFlowTasksList,
  estadoActividad,
} from "../../../redux/on&offBoarning/workFlowTaskList/actions";
import { getUsers } from "../../../redux/auth/actions";
import { enviarCorreo } from "../../../redux/on&offBoarning/capacitacion/actions";
import {
  getAreas,
  getCarpetas,
  getDocs,
} from "../../../redux/gestorDocumental/actions";
//
import * as Yup from "yup";
import { Formik } from "formik";
import moment from "moment";

const WorkFlowTaskList = (props) => {
  const filters = [
    { id: "empleado_nombre", desc: "Nombre colaborador" },
    { id: "empleado_codigo", desc: "Código colaborador" },
    { id: "nombre_workflow", desc: "Nombre workflow" },
    { id: "nombre", desc: "Nombre actividad" },
    { id: "calificacion", desc: "Calificación" },
    { id: "estado", desc: "Estado" },
  ];
  //variables hooks
  const [show, setShow] = useState(false);
  const [edit, setEdit] = useState(false);
  const [item, setItem] = useState(null);
  const [validated, setValidated] = useState(false);
  const [showSidebard, setShowSideBar] = useState(false);
  const [oData, setOData] = useState([]);
  const [userSelected, setUserSelected] = useState([]);
  const [fileName, setFileName] = useState("Imagen, pdf, documento, etc.");
  const [filter, setFilter] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState(
    props.match.params.searchFilter &&
      filters.find((f) => f.num === parseInt(props.match.params.searchFilter))
      ? filters.find((f) => f.num === parseInt(props.match.params.searchFilter))
      : filters[0]
  );

  //
  const dispatch = useDispatch();
  const { goBack } = useHistory();
  const history = useHistory();
  //paginación
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const schema = Yup.object().shape({
    descripcion: Yup.string().required("**Campo requerido"),
    compa_guia: Yup.string().required("**Campo requerido"),
    enlace_evaluacion: Yup.string().notRequired(""),
    fecha_inicio: Yup.string().required("**Campo requerido"),
    fecha_fin: Yup.string().required("**Campo requerido"),
    subir_archivo: Yup.boolean().notRequired(""),
    archivo_bajar: Yup.string().notRequired(),
    // .when("edit", {
    //   is: () => edit && !item.archivo_bajar,
    //   then: Yup.string().required("**Campo requerido"),
    // }),
    calificacion: Yup.number()
      .min(0, "El valor minimo es 0.")
      .when("edit", {
        is: () => edit && item.evaluable,
        then: Yup.number().required("**Campo requerido"),
      }),
  });

  //* Redux
  const {
    loaderWorkFlowTasksList,
    saveLoaderWorkFlowTaskList,
    workflowTasksList,
    formErrorsWorkflowTaskList,
    errorWorkflowTaskList,
  } = useSelector((store) => store.workflowTaskList);

  const { loadingAuth, users, userRoles } = useSelector((store) => store.auth);

  const { errorCorreoOnboarding } = useSelector((store) => store.capacitacion);

  const userId = useSelector((store) => store.auth.id);
  const userN = useSelector((store) => store.auth.username);

  const { email } = config.gestorDocumental;

  const { tipoDocumento } = config.gestorDocumental.onboarding;

  //Metodos
  let usersOptions = [];
  users.map((user) => {
    usersOptions = [
      ...usersOptions,
      {
        id: user.id,
        label: `${user.username}-${user.first_name} ${user.last_name}`,
      },
    ];
  });
  const pages = Math.ceil(
    workflowTasksList ? workflowTasksList.count / limit : 0
  );

  const _getWorkFlowTaskList = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getWorkFlowTasksList({
        offset: offs,
        limit: lim,
        tipo_workflow: parseInt(props.match.params.tipo),
        filter: filt,
        tipo_busqueda: tipoBusqueda.id,
      })
    );

  useEffect(() => {
    dispatch(getUsers({}));
  }, [dispatch]);

  useEffect(() => {
    if (userN !== "") {
      dispatch(
        getDocs({
          id_empleado: parseInt(userId),
          tipo_documento: tipoDocumento,
        })
      );
      dispatch(getAreas());
      dispatch(getCarpetas());
    }
  }, [props.match.params.id, userN, userId]);

  useEffect(() => {
    _getWorkFlowTaskList();
  }, []);

  const handleEditWorkFlow = (item, rowIndx) => {
    setEdit(true);
    setItem(item);
    if (item.archivo_bajar !== "" || item.archivo_bajar !== null) {
      setFileName(item.archivo_bajar);
    } else {
      setFileName("Imagen, pdf, documento, etc.");
    }
    setShow(true);
    setUserSelected(
      item &&
        item.datos_guia_responsable &&
        item.datos_guia_responsable[0] &&
        item.datos_guia_responsable[0].id
        ? [
            {
              id: item.datos_guia_responsable[0].id,
              label: `${item.datos_guia_responsable[0].username} - ${item.datos_guia_responsable[0].first_name} ${item.datos_guia_responsable[0].last_name}`,
            },
          ]
        : []
    );
    setValidated(false);
  };

  const onSubmit = (req) => {
    // debugger;
    const _req = new FormData();
    var sameComp = false;

    if (
      userSelected &&
      userSelected[0] &&
      userSelected[0].id &&
      item.compa_guia === userSelected[0].id
    ) {
      sameComp = true;
    }

    if (item.compa_guia === null && userSelected.length === 0) {
      sameComp = true;
    }

    _req.append("id", item.id);
    _req.append("descripcion", item.descripcion);
    _req.append("estado", item.estado);
    _req.append("evaluable", item.evaluable);
    _req.append("subir_archivo", req.subir_archivo);
    _req.append("fecha_inicio", moment(req.fecha_inicio).format("YYYY-MM-DD"));
    _req.append("fecha_fin", moment(req.fecha_fin).format("YYYY-MM-DD"));
    if (item.evaluable) {
      _req.append(
        "calificacion",
        req.calificacion
          ? parseFloat(req.calificacion)
          : parseFloat(item.calificacion)
      );
    }
    _req.append("enlace_evaluacion", req.enlace_evaluacion);
    if (fileName === "Imagen, pdf, documento, etc.") {
      _req.append("archivo_bajar", "");
    } else {
      if (document.getElementById("archivo_bajar").files.length > 0) {
        _req.append(
          "archivo_bajar",
          document.getElementById("archivo_bajar").files[0]
        );
      }
    }
    _req.append("posicion", item.posicion);
    _req.append("bloque", item.bloque);
    if (userSelected.length > 0) {
      _req.append(
        "compa_guia",
        userSelected && userSelected[0] && userSelected[0].id
          ? userSelected[0].id
          : null
      );
    }
    dispatch(
      editWorkFlowTaskList(
        _req,
        item.id,
        parseInt(item.workflow_list[0].id),
        parseInt(item.bloque),
        parseInt(item.id),
        sameComp
      )
    );

    setShow(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    if (!e.target.filter.value.trim()) {
      return;
    }
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getWorkFlowTaskList(oOffset, limit, e.target.filter.value);
  };

  const onSearchState = (e) => {
    e.preventDefault();
    // if (!e.currentTarget.value.trim()) {
    //   return;
    // }
    setFilter(e.currentTarget.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getWorkFlowTaskList(oOffset, limit, e.currentTarget.value);
  };

  const seeAll = () => {
    const ofilter = "";
    setFilter(ofilter);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getWorkFlowTaskList(oOffset, limit, ofilter);
  };

  const handleCheckbox = ({ target: { checked, value: checkValue } }) => {
    if (checked) {
      const value = JSON.parse(checkValue);
      const sigIndex = value.index + 1;
      if (
        (value.evaluable &&
          value.calificacion &&
          parseFloat(value.calificacion).toFixed(2) >
            parseFloat(80).toFixed(2)) ||
        (value.evaluable &&
          value.subir_archivo &&
          value.archivos_gestor !== null &&
          !value.estado) ||
        (value.evaluable && !value.subir_archivo && !value.estado)
      ) {
        dispatch(
          estadoActividad(
            {
              tarea: parseInt(value.id),
            },
            parseInt(value.index)
          )
        );
        if (oData[sigIndex]) {
          dispatch(
            enviarCorreo({
              workflow_id: parseInt(value.workflow),
              bloque_id: parseInt(value.bloque),
              tarea_id: parseInt(oData[sigIndex].id),
              tipo_mensaje: "Jefe - Retraso en Tareas",
            })
          );
          dispatch(
            enviarCorreo({
              workflow_id: parseInt(value.workflow),
              bloque_id: parseInt(value.bloque),
              tarea_id: parseInt(oData[sigIndex].id),
              tipo_mensaje: "Responsable - Nota Evaluacion",
            })
          );
        }
      } else if (
        !value.evaluable &&
        ((value.subir_archivo &&
          value.archivos_gestor !== null &&
          !value.estado) ||
          (!value.subir_archivo && !value.estado))
      ) {
        dispatch(
          estadoActividad(
            {
              tarea: parseInt(value.id),
            },
            parseInt(value.index)
          )
        );
        if (oData[sigIndex]) {
          dispatch(
            enviarCorreo({
              workflow_id: parseInt(value.workflow),
              bloque_id: parseInt(value.bloque),
              tarea_id: parseInt(oData[sigIndex].id),
              tipo_mensaje: "Jefe - Retraso en Tareas",
            })
          );
          dispatch(
            enviarCorreo({
              workflow_id: parseInt(value.workflow),
              bloque_id: parseInt(value.bloque),
              tarea_id: parseInt(oData[sigIndex].id),
              tipo_mensaje: "Responsable - Nota Evaluacion",
            })
          );
        }
      } else {
        toastr.info("La tarea no puede ser actualizada");
      }
    }
  };

  const onShowSidebar = () => setShowSideBar(showSidebard ? false : true);
  const handleClose = () => setShow(false);

  return (
    <div className="p-lg-2 p-md-2">
      <CustomNavbar />

      <SidebarDashboard show={showSidebard} onShowSidebar={onShowSidebar} />

      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="mb-4">
            {userRoles &&
            (userRoles.includes("jefe") ||
              userRoles.includes("Responsable_OnBoarding") ||
              userRoles.includes("Responsable_OffBoarding") ||
              userRoles.includes("administrador")) ? (
              <>
                <div className="d-flex justify-content-start align-items-center">
                  <Button
                    onClick={() => goBack(-1)}
                    variant="link"
                    className="font-weight-bold mr-4 text-dark"
                  >
                    <i className="material-icons">arrow_back</i>
                  </Button>
                  <Breadcrumb className="pb-0">
                    <Breadcrumb.Item
                      title
                      className="text-uppercase"
                      onClick={() => history.goBack()}
                    >
                      <i
                        className="flex-wrap material-icons"
                        style={{ fontSize: "2rem", marginTop: "-.5rem" }}
                      >
                        computer
                      </i>
                      {props.match.params.tipo == 1
                        ? "MONITOR ONBOARDING"
                        : "MONITOR OFFBOARDING"}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active title className="text-uppercase">
                      <i
                        className="material-icons"
                        style={{ fontSize: "2rem", marginTop: "-.5rem" }}
                      >
                        folder
                      </i>
                      TAREAS
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </div>
                <hr />
              </>
            ) : (
              ""
            )}
            {/* <h5 className="mr-3 mb-3 text-uppercase text-muted">
              persona responsable:{" "}
              <span className="bg-info p-1 rounded-pill text-white">
                {workflowTasksList ? workflowTasksList.nombre : null}
              </span>
            </h5> */}
          </div>
          {/* <Row className="justify-content-start align-items-center flex-nowrap">
            <Col xs="auto" className="px-1  text-muted ">
              <h4 className="m-0 ml-3 d-flex justify-content-start align-items-center">
                <i className="material-icons">task</i> Actividades
              </h4>
            </Col>
          </Row> */}
          <div
            className={`my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center`}
          >
            <h4 className="m-0 ml-3 d-flex justify-content-start align-items-center">
              <i className="material-icons">task</i> Actividades
            </h4>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  {tipoBusqueda.id === "estado" ? (
                    <Form.Control
                      as="select"
                      name="filter"
                      id="filter"
                      placeholder="Buscar"
                      className="rounded-pill form-control-sm"
                      onChange={onSearchState}
                      style={{ minWidth: "174px" }}
                    >
                      <option
                        className="text-muted"
                        key={0}
                        value=""
                        //  selected
                        //  disabled
                      ></option>
                      <option key={1} value="False">
                        Abierto
                      </option>
                      <option key={1} value="True">
                        Cerrado
                      </option>
                    </Form.Control>
                  ) : (
                    <Form.Control
                      name="filter"
                      id="filter"
                      placeholder="Buscar"
                      className="rounded-pill form-control-sm"
                      type="search"
                    ></Form.Control>
                  )}
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Dropdown className="mx-1">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {!!errorWorkflowTaskList && (
            <Alert variant="danger" className="mt-4 mb-1">
              {errorWorkflowTaskList}
            </Alert>
          )}
          <Card className="border-0 mt-2">
            <Card.Body className="px-0">
              {loaderWorkFlowTasksList ? (
                <div className="d-flex justify-content-center">
                  <Spinner
                    animation="border"
                    role="status"
                    className="d-flex justify-content-center"
                  />
                </div>
              ) : workflowTasksList && workflowTasksList.count > 0 ? (
                <>
                  <Table responsive="sm" striped>
                    <thead>
                      <tr>
                        <th>Workflow</th>
                        <th>Actividad</th>
                        <th>Fecha de inicio</th>
                        <th>Fecha de fin</th>
                        <th>Calificación</th>
                        <th>Estado</th>
                        <th>Código de colaborador</th>
                        <th>Colaborador</th>
                        <th>Responsable</th>
                        <th></th>
                      </tr>
                    </thead>
                    {workflowTasksList.data.map((item, index) => (
                      <tr key={item.id}>
                        <td className="d-flex align-items-center">
                          {item.workflow_list[0].nombre}
                        </td>
                        <td className="align-items-center">{item.nombre}</td>
                        <td>
                          {moment(item.fecha_inicio).format("DD/MM/YYYY")}
                        </td>
                        <td>
                          <div
                            style={{ width: "8.9rem" }}
                            className={`rounded-pill text-white text-center px-2 ${
                              moment(moment().format("YYYY-MM-DD")).diff(
                                moment(item.fecha_fin),
                                "days"
                              ) > 0
                                ? "bg-danger"
                                : moment(item.fecha_fin).diff(
                                    moment(moment().format("YYYY-MM-DD")),
                                    "days"
                                  ) === 1
                                ? "bg-info"
                                : "bg-success"
                            }`}
                          >
                            {moment(item.fecha_fin).format("DD/MM/YYYY")}
                          </div>
                        </td>
                        <td>
                          {item.evaluable && item.calificacion
                            ? parseFloat(item.calificacion).toFixed(2) + "%"
                            : null}
                        </td>
                        <td>
                          <div className="d-flex justify-content-between">
                            <div
                              className={`rounded-pill ${
                                item.estado ? "bg-success" : "bg-danger"
                              }`}
                              style={{
                                width: "3rem",
                                height: "1rem",
                                marginRight: ".6rem",
                              }}
                            ></div>
                            <Form.Check
                              inline
                              value={JSON.stringify({
                                id: item.id,
                                index: index,
                                evaluable: item.evaluable,
                                calificacion: item.calificacion,
                                subir_archivo: item.subir_archivo,
                                archivos_gestor: item.archivos_gestor,
                                workflow: item.workflow_list[0].id,
                                bloque: item.bloque,
                              })}
                              disabled={
                                (item.evaluable &&
                                  item.calificacion &&
                                  parseFloat(item.calificacion) < 80) ||
                                (item.subir_archivo &&
                                  item.archivos_gestor === null) ||
                                item.estado
                                // ||
                                // userRoles.includes("jefe")
                              }
                              onChange={handleCheckbox}
                              checked={item.estado ? true : null}
                            />
                          </div>
                        </td>
                        <td>
                          {item.datos_colaborador &&
                          item.datos_colaborador.length > 0
                            ? `${item.datos_colaborador[0].codigo}`
                            : null}
                        </td>
                        <td>
                          {item.datos_colaborador &&
                          item.datos_colaborador.length > 0
                            ? `${item.datos_colaborador[0].nombre}`
                            : null}
                        </td>
                        <td>
                          {item.datos_guia_responsable &&
                          item.datos_guia_responsable.length > 0
                            ? `${item.datos_guia_responsable[0].first_name} ${item.datos_guia_responsable[0].last_name}`
                            : null}
                        </td>
                        <td>
                          <div className="btn-group" role="group">
                            {/* {(userRoles.includes("Responsable_OnBoarding") ||
                              userRoles.includes(
                                "Responsable_OffBoarding"
                              )) && ( */}
                            <OverlayTrigger
                              placement="auto"
                              overlay={
                                <Tooltip {...props}>Editar actividad</Tooltip>
                              }
                            >
                              <Button
                                size="sm"
                                variant="link"
                                type="button"
                                onClick={() => handleEditWorkFlow(item, index)}
                              >
                                <i className="material-icons">edit</i>
                              </Button>
                            </OverlayTrigger>
                            {/* )} */}
                            {item.archivo_bajar && (
                              <OverlayTrigger
                                placement="auto"
                                overlay={
                                  <Tooltip {...props}>
                                    Ver documento subido
                                  </Tooltip>
                                }
                              >
                                <a
                                  rel="noreferrer"
                                  target="_blank"
                                  href={`${process.env.REACT_APP_URL}/media/${item.archivo_bajar}`}
                                  className="btn btn-default btn-sm text-muted"
                                >
                                  <i className="material-icons">plagiarism</i>
                                </a>
                              </OverlayTrigger>
                            )}
                            {item.archivos_gestor && (
                              <OverlayTrigger
                                placement="auto"
                                overlay={
                                  <Tooltip {...props}>
                                    Ver documento subido por el colaborador
                                  </Tooltip>
                                }
                              >
                                <LinkDescargaListGD
                                  id={item.id}
                                  filters={{
                                    email: email,
                                    id: item.archivo_gestor[0].id_documento,
                                    llave: item.archivo_gestor[0].llave,
                                  }}
                                  origen={item.archivo_gestor[0].origen}
                                  icono={<i className="material-icons">file</i>}
                                  cType={item.archivo_gestor[0].contentTypeGD}
                                />
                              </OverlayTrigger>
                            )}
                            {/* {(userRoles.includes("Responsable_OnBoarding") ||
                              userRoles.includes(
                                "Responsable_OffBoarding"
                              )) && (
                              <OverlayTrigger
                                placement="auto"
                                overlay={
                                  <Tooltip {...props}>
                                    Enviar Notificación
                                  </Tooltip>
                                }
                              >
                                <Button
                                  size="sm"
                                  variant="link"
                                  type="button"
                                  onClick={() =>
                                    dispatch(
                                      enviarCorreo({
                                        workflow_id: parseInt(
                                          item.workflow_list[0].id
                                        ),
                                        bloque_id: parseInt(item.bloque),
                                        tarea_id: parseInt(item.id),
                                        tipo_mensaje:
                                          "Jefe - Retraso en Tareas",
                                      })
                                    )
                                  }
                                >
                                  <i className="material-icons">
                                    outgoing_mail
                                  </i>
                                </Button>
                              </OverlayTrigger>
                            )} */}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </Table>
                  <CustomPagint
                    limit={limit}
                    setLimit={setLimit}
                    offset={offset}
                    setOffset={setOffset}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    dataLenght={workflowTasksList ? workflowTasksList.count : 0}
                    pages={pages}
                    pagFunc={_getWorkFlowTaskList}
                  />
                </>
              ) : (
                <Alert variant="info">
                  Aún no hay procesos registrados, comienza agregando algunos.
                </Alert>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>

      {/* modal */}
      <Modal show={show} onHide={handleClose}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            descripcion: edit ? item.descripcion : "",
            compa_guia: edit ? item.compa_guia : "",
            enlace_evaluacion: edit ? item.enlace_evaluacion : "",
            fecha_inicio: edit ? item.fecha_inicio : "",
            fecha_fin: edit ? item.fecha_fin : "",
            subir_archivo: edit ? item.subir_archivo : "",
            archivo_bajar: "",
            calificacion:
              edit && item.calificacion ? parseFloat(item.calificacion) : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title>
                  {edit ? `Editar Actividad ${item.nombre}` : "Crear Actividad"}
                </Modal.Title>
              </Modal.Header>

              <Modal.Body>
                {formErrorsWorkflowTaskList && (
                  <Alert variant="danger">
                    <h6 className="font-weight-bold">
                      Hemos experimentado los suguientes errores:
                    </h6>
                    {Array.isArray(formErrorsWorkflowTaskList) ? (
                      <ul className="list-unstyled">
                        {formErrorsWorkflowTaskList.map((item, inx) => (
                          <li key={inx}>{item}</li>
                        ))}
                      </ul>
                    ) : (
                      formErrorsWorkflowTaskList
                    )}
                  </Alert>
                )}
                {!!errorCorreoOnboarding && (
                  <Alert variant="danger">
                    <p className="m-0">
                      <i className="material-icons text-danger">warning</i>
                      {errorCorreoOnboarding && errorCorreoOnboarding.mensaje
                        ? errorCorreoOnboarding.mensaje
                        : errorCorreoOnboarding}
                    </p>
                  </Alert>
                )}
                {edit &&
                moment(moment().format("YYYY-MM-DD")).diff(
                  moment(item.fecha_fin),
                  "days"
                ) > 0 ? (
                  <Alert variant="danger">
                    <p className="m-0">
                      <i className="material-icons text-danger">warning</i> ¡La
                      tarea está atrasada!
                    </p>
                  </Alert>
                ) : null}
                {edit &&
                moment(item.fecha_fin).diff(
                  moment(moment().format("YYYY-MM-DD")),
                  "days"
                ) === 1 ? (
                  <Alert variant="info">
                    <p className="m-0">
                      <i className="material-icons text-info">info</i> ¡La tarea
                      está a punto de expirar!
                    </p>
                  </Alert>
                ) : null}
                {edit &&
                moment(item.fecha_fin).diff(
                  moment(moment().format("YYYY-MM-DD")),
                  "days"
                ) === 0 ? (
                  <Alert variant="info">
                    <p className="m-0">
                      <i className="material-icons text-info">info</i> ¡La tarea
                      expira hoy!
                    </p>
                  </Alert>
                ) : null}
                <Form.Group className="mb-3">
                  <Form.Label className="ml-2">Descripción</Form.Label>
                  <Form.Control
                    as="textarea"
                    id="descripcion"
                    name="descripcion"
                    placeholder="Descripción"
                    disabled
                    readOnly
                    onChange={(e) => handleChange(e)}
                    isInvalid={touched.descripcion && errors.descripcion}
                    isValid={touched.descripcion && !errors.descripcion}
                    onBlur={handleBlur("descripcion")}
                    value={values.descripcion}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.descripcion}
                  </Form.Control.Feedback>
                  {formErrorsWorkflowTaskList &&
                  typeof formErrorsWorkflowTaskList === "object" &&
                  formErrorsWorkflowTaskList.descripcion ? (
                    <ul className="list-unstyled text-danger ml-2">
                      {formErrorsWorkflowTaskList.descripcion.map((item) => (
                        <li>{item}</li>
                      ))}
                    </ul>
                  ) : null}
                </Form.Group>
                <Row className="align-items-end mb-3">
                  <Col sm={loadingAuth ? 10 : 12}>
                    <Form.Label className="ml-1">
                      Responsable de la actividad
                    </Form.Label>
                    <Typeahead
                      id="compa_guia"
                      name="compa_guia"
                      isInvalid={touched.compa_guia && errors.compa_guia}
                      isValid={touched.compa_guia && !errors.compa_guia}
                      onBlur={handleBlur("compa_guia")}
                      options={usersOptions}
                      onChange={(selected) => {
                        setFieldValue(
                          "compa_guia",
                          selected.length > 0 ? selected[0].id : ""
                        );
                        setUserSelected(selected);
                      }}
                      selected={userSelected}
                      disabled={
                        userRoles.length > 0 &&
                        !(
                          userRoles.includes("Responsable_OnBoarding") ||
                          userRoles.includes("Responsable_OffBoarding") ||
                          userRoles.includes("administrador")
                        )
                      }
                    ></Typeahead>
                  </Col>
                  {loadingAuth && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
                {item && item.evaluable && (
                  <Row>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label className="ml-1" sm="12" md="3">
                        Calificación:
                      </Form.Label>
                      <Form.Control
                        id="calificacion"
                        name="calificacion"
                        className="rounded-pill"
                        type="number"
                        isInvalid={touched.calificacion && errors.calificacion}
                        isValid={touched.calificacion && !errors.calificacion}
                        value={values.calificacion}
                        placeholder="0.00"
                        step="0.01"
                        min="0"
                        onChange={(e) => handleChange(e)}
                        max="100"
                        disabled={
                          userRoles.length > 0 &&
                          !(
                            userRoles.includes("Responsable_OnBoarding") ||
                            userRoles.includes("Responsable_OffBoarding") ||
                            userRoles.includes("administrador")
                          )
                        }
                      ></Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.calificacion}
                      </Form.Control.Feedback>
                      {formErrorsWorkflowTaskList &&
                      typeof formErrorsWorkflowTaskList === "object" &&
                      formErrorsWorkflowTaskList.calificacion ? (
                        <ul className="list-unstyled text-danger ml-2">
                          {formErrorsWorkflowTaskList.calificacion.map(
                            (item) => (
                              <li>{item}</li>
                            )
                          )}
                        </ul>
                      ) : null}
                    </Form.Group>
                  </Row>
                )}
                <Row>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label className="ml-1" sm="12" md="3">
                      Enlace clima laboral:
                    </Form.Label>
                    <Form.Control
                      name="enlace_evaluacion"
                      className="rounded-pill"
                      id="enlace_evaluacion"
                      type="text"
                      isInvalid={
                        touched.enlace_evaluacion && errors.enlace_evaluacion
                      }
                      isValid={
                        touched.enlace_evaluacion && !errors.enlace_evaluacion
                      }
                      onChange={(e) => handleChange(e)}
                      value={values.enlace_evaluacion}
                      placeholder="Enlace clima laboral"
                      disabled={
                        userRoles.length > 0 &&
                        !(
                          userRoles.includes("Responsable_OnBoarding") ||
                          userRoles.includes("Responsable_OffBoarding") ||
                          userRoles.includes("administrador")
                        )
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.enlace_evaluacion}
                    </Form.Control.Feedback>
                    {formErrorsWorkflowTaskList &&
                    typeof formErrorsWorkflowTaskList === "object" &&
                    formErrorsWorkflowTaskList.enlace_evaluacion ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formErrorsWorkflowTaskList.enlace_evaluacion.map(
                          (item) => (
                            <li>{item}</li>
                          )
                        )}
                      </ul>
                    ) : null}
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label className="ml-2">Fecha de inicio</Form.Label>
                    <Form.Control
                      id="fecha_inicio"
                      name="fecha_inicio"
                      type="date"
                      placeholder="Fecha de inicio"
                      className="rounded-pill"
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.fecha_inicio && errors.fecha_inicio}
                      isValid={touched.fecha_inicio && !errors.fecha_inicio}
                      value={values.fecha_inicio}
                      disabled={
                        userRoles.length > 0 &&
                        !(
                          userRoles.includes("Responsable_OnBoarding") ||
                          userRoles.includes("Responsable_OffBoarding") ||
                          userRoles.includes("administrador")
                        )
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.fecha_inicio}
                    </Form.Control.Feedback>
                    {formErrorsWorkflowTaskList &&
                    typeof formErrorsWorkflowTaskList === "object" &&
                    formErrorsWorkflowTaskList.fecha_inicio ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formErrorsWorkflowTaskList.fecha_inicio.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label className="ml-2">Fecha de fin</Form.Label>
                    <Form.Control
                      id="fecha_fin"
                      name="fecha_fin"
                      type="date"
                      placeholder="Fecha de fin"
                      className="rounded-pill"
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.fecha_fin && errors.fecha_fin}
                      isValid={touched.fecha_fin && !errors.fecha_fin}
                      value={values.fecha_fin}
                      disabled={
                        userRoles.length > 0 &&
                        !(
                          userRoles.includes("Responsable_OnBoarding") ||
                          userRoles.includes("Responsable_OffBoarding") ||
                          userRoles.includes("administrador")
                        )
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.fecha_fin}
                    </Form.Control.Feedback>
                    {formErrorsWorkflowTaskList &&
                    typeof formErrorsWorkflowTaskList === "object" &&
                    formErrorsWorkflowTaskList.fecha_fin ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {formErrorsWorkflowTaskList.fecha_fin.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                </Row>

                <Row>
                  <Col md="4">
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip style={{ zIndex: 999999999999 }} {...props}>
                          Habilita si el empleado puede subir archivos o no
                        </Tooltip>
                      }
                    >
                      <Form.Check
                        type="checkbox"
                        defaultChecked={item ? item.subir_archivo : false}
                        value={values.subir_archivo}
                        className="mx-1"
                        name="subir_archivo"
                        id="subir_archivo"
                        label="Subir archivos"
                        onChange={(e) => {
                          setFieldValue("subir_archivo", e.target.checked);
                        }}
                        isInvalid={
                          touched.subir_archivo && errors.subir_archivo
                        }
                        isValid={touched.subir_archivo && !errors.subir_archivo}
                      />
                    </OverlayTrigger>
                  </Col>
                </Row>

                <Row>
                  <Form.Group as={Col} className="py-2 px-3 mb-3">
                    <Form.Label className="ml-1" sm="12" md="3">
                      Archivo para descargar:
                    </Form.Label>
                    <Form.File
                      className="position-relative shadow-sm"
                      name="archivo_bajar"
                      label="Archivo para descargar:"
                      id="archivo_bajar"
                      value={values.archivo_bajar}
                      custom
                      style={{ fontWeight: "bold" }}
                      onChange={
                        (e) => handleChange(e)
                        // e.target.files && e.target.files[0].name
                        //   ? setFileName(e.target.files[0].name)
                        //   : null
                      }
                    />
                    <h6
                      className="p-2 mt-2 shadow-sm rounded"
                      style={{
                        border: "1px solid #ced4da",
                        width: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {item && fileName !== item.archivo_bajar
                        ? fileName
                        : "Imagen, pdf, documento, etc."}
                    </h6>
                  </Form.Group>
                  {touched.archivo_bajar && errors.archivo_bajar && (
                    <Col>
                      <small className="text-danger">
                        {errors.archivo_bajar}
                      </small>
                    </Col>
                  )}
                </Row>
                {item && item.subir_archivo && item.archivos_gestor && (
                  <Row>
                    <Col className="px-3 ml-1 mb-3">
                      <h6 className="text-muted ml-3">
                        Ver documento subido por el colaborador:
                      </h6>
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip
                            style={{
                              zIndex: 999999999999,
                              maxWidth: "500px",
                            }}
                            {...props}
                          >
                            Ver documento subido por el colaborador
                          </Tooltip>
                        }
                      >
                        <>
                          <ul className="list-unstyled">
                            <LinkDescargaGD
                              id={item.id}
                              filters={{
                                email: email,
                                id: item.archivo_gestor[0].id_documento,
                                llave: item.archivo_gestor[0].llave,
                              }}
                              origen={item.archivo_gestor[0].origen}
                              cType={item.archivo_gestor[0].contentTypeGD}
                            />
                          </ul>
                        </>
                      </OverlayTrigger>
                    </Col>
                  </Row>
                )}
              </Modal.Body>

              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={handleClose}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={
                    saveLoaderWorkFlowTaskList ||
                    (item && item.estado ? item.estado : false)
                  }
                  variant="primary"
                  type="submit"
                >
                  {saveLoaderWorkFlowTaskList ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      {/* fin modal */}
    </div>
  );
};

export default WorkFlowTaskList;
